export default __webpack_public_path__ + "982b1023986064ac0b5c38d73e071680.png";